export const GUEST_TYPE_COMPANION = "COMPANION";
export const GUEST_TYPE_CHILD = "CHILD";
export const GUEST_TYPE_OTHER_ADULT = "OTHER_ADULT";

export const registrationGuestsTypes = {
  [GUEST_TYPE_COMPANION]: "Conjoint",
  [GUEST_TYPE_CHILD]: "Enfant",
  [GUEST_TYPE_OTHER_ADULT]: "Autre adulte",
};
